import 'react-app-polyfill/stable'

import { GlobalStyle, ThemeProvider } from '@community_dev/pixels'
import LIGHT from '@community_dev/pixels/dist/js/themes/presets/light'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { createGlobalStyle } from 'styled-components'

import App from './App'

import Sentry from 'integrations/Sentry'

if (import.meta.env.DEV && (window as any).Cypress === undefined) {
  import('./mocks/browser')
    .then(({ worker }) => {
      const publicUrl = import.meta.env.VITE_PUBLIC_URL || ''
      worker.start({
        serviceWorker: {
          url: `${publicUrl.replace(/\/$/, '')}/mockServiceWorker.js`,
        },
        onUnhandledRequest: 'bypass',
      })
    })
    .catch(Sentry.captureException)
}

const StyledGlobal = createGlobalStyle`
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }

  html {
    height: 100%
  }

  body {
    display: flex;
    align-items: stretch;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.096px;
    min-height: 100%;
  }
  #root {
    width: 100%
  }
`

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={LIGHT}>
        <GlobalStyle />
        <StyledGlobal />
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)

declare global {
  interface Window {
    Cypress: unknown
  }
}
